// extracted by mini-css-extract-plugin
module.exports = {"toggleQueuePrompt":"ToggleQueueCardsPrompt_toggleQueuePrompt__dqwDq"};